import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  permissionStack: {
    width: '85%',
  },
  iconClass: {
    color: theme.palette.themePrimary,
    paddingLeft: pxToRem(5),
  },
  permissionsHeader: {
    selectors: {
      '& .ms-DetailsHeader-cellName': {
        height: pxToRem(20),
      },
    },
  },
});
